module.exports = __webpack_public_path__ + "static/media/talk.346aa700.png";